import useTranslation from "next-translate/useTranslation"
import { useState } from "react"

import { IProject, IProjectMembership, MembershipRole, ProjectState } from "@api/schema"
import ActionIcon from "@components/common/ActionIcon"
import { IFormikActions } from "@redux/helper/actions"
import { Routes, routeWithParams } from "@services/routes"
import { MODULE_FEEDBACK_FOR_PROJECTS_AVAILABLE, MODULE_JITSI__SERVICE } from "config"

import ProjectStateModal from "./ProjectStateModal"

interface IProps {
  membership: IProjectMembership
  project: IProject
  updateProject: (data: IProject, actions: IFormikActions) => void
}

/**
 * This component provides the navigation-icons at the workflow for a single project,
 * in which the user is a member.
 */

const ProgressActionIcons: React.FC<IProps> = ({ membership, project, updateProject }: IProps) => {
  const { t } = useTranslation("common")

  const [stateModalOpen, setStateModalOpen] = useState(false)
  const toggleProjectStateModal = () => setStateModalOpen(!stateModalOpen)

  const onEditSubmit = (values: IProject, actions: IFormikActions): void => {
    actions.onSuccess = () => {
      toggleProjectStateModal()
    }
    // data has been prepared on ProjectStateForm
    updateProject(values, actions)
  }

  return <div role="actions" className="icon-navigation">
    {membership.role === MembershipRole.Coordinator &&
      <ActionIcon
        aria-label={t("goto.editProjectState")}
        onclick={toggleProjectStateModal}
        title={t("goto.editProjectState")}
        icon="preferences"
      />
    }
    {MODULE_FEEDBACK_FOR_PROJECTS_AVAILABLE &&
      <ActionIcon
        aria-label={t("goto.projectFeedback")}
        href={routeWithParams(Routes.ProjectFeedbackDashboard, { slug: project.slug || project.id })}
        title={t("goto.projectFeedback")}
        icon="comment"
      />
    }
    {!project.locked && project.state !== ProjectState.Deactivated &&
      <ActionIcon
        aria-label={t("goto.publicProjectProfile")}
        href={routeWithParams(Routes.ProjectPage, { slug: project.slug || project.id })}
        title={t("goto.publicProjectProfile")}
        icon="market"
      />
    }

    {MODULE_JITSI__SERVICE && project.memberships?.length > 1 && !project.locked && // show teammeeting, when there are possible participants (#>1) in the team; do not use memberCount because it does not count observers
      <ActionIcon
        aria-label={t("goto.teamMeeting")}
        href={routeWithParams(Routes.TeamMeeting, { slug: project.slug || project.id })}
        title={t("goto.teamMeeting")}
        icon="videoconference"
      />
    }
    {<ActionIcon
      aria-label={t("goto.teamUploads")}
      href={routeWithParams(Routes.TeamUpload, { slug: project.slug || project.id })}
      title={t("goto.teamUploads")}
      icon="teamuploads"
    />
    }
    <ActionIcon
      aria-label={t("goto.projectMemberships")}
      href={routeWithParams(Routes.ProjectMembers, { slug: project.slug || project.id })}
      title={t("goto.projectMemberships")}
      icon="user-multiple"
    />
    {/* <Link href="/">
      <a aria-label="add participants" className="actionicon">
        <Icon name={"user-multiple"} size={24} />
      </a>
    </Link>
    <Link href="/">
      <a aria-label="download"  className="actionicon">
        <Icon name={"download-cloud"} size={24} />
      </a>
    </Link>*/}

    <ProjectStateModal
      project={project}
      modalOpen={stateModalOpen}
      onSubmit={onEditSubmit}
      toggle={toggleProjectStateModal}
    />
  </div>
}

export default ProgressActionIcons
